import React from 'react'
import { CloseButton, Text } from '@mote/ui/components'
import { forwardRef } from '@mote/ui/system'
import { x } from '@xstyled/styled-components'

export interface HintProps {
  text: string
  isClearable?: boolean
  onClear?: () => void
  onClick?: () => void
}

export const Hint = forwardRef<HintProps, 'button' | 'div'>(
  ({ text, isClearable, onClear, onClick }, ref) => {
    const shared = {
      ref,
      display: 'flex',
      alignItems: 'center',
      borderRadius: 'md',
      w: 'max-content',
      maxW: 'full',
      h: 6,
      px: 2
    }

    if (isClearable) {
      return (
        <x.div cursor='default' bg='grey.d2' gap={1} {...shared}>
          <Text
            as='span'
            fontSize='sm'
            lineHeight='sm'
            color='white'
            fontWeight='medium'
            overflow='hidden'
            whiteSpace='nowrap'
            textOverflow='ellipsis'
          >
            {text}
          </Text>
          {isClearable && onClear && (
            <CloseButton
              size={20}
              onClick={onClear}
              borderRadius='full'
              backgroundColor={{ hover: 'transparent', focus: 'transparent' }}
              color={{
                _: 'white',
                hover: 'grey.l3',
                focue: 'grey.l3'
              }}
            />
          )}
        </x.div>
      )
    }

    return (
      <x.button
        appearance='none'
        userSelect='none'
        cursor='pointer'
        bg={{
          _: 'grey.d2',
          hover: 'grey.d3',
          active: 'grey.d4'
        }}
        boxShadow={{
          _: 'none',
          focus: 'outline-primary'
        }}
        transition
        onClick={onClick}
        {...shared}
      >
        <Text
          as='span'
          fontSize='sm'
          lineHeight='sm'
          color='white'
          fontWeight='medium'
          overflow='hidden'
          whiteSpace='nowrap'
          textOverflow='ellipsis'
        >
          {text}
        </Text>
      </x.button>
    )
  }
)
